module.exports = __webpack_public_path__ + "img/ccf-de-DE.70aa86c5.png";